import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      border: '1px solid #D2D2D2',
      borderRadius: 6,
      padding: theme.spacing(1, 1.5, 2.75),

      '& > header': {
        marginBottom: theme.spacing(2),

        display: 'flex',
        alignItems: 'flex-end',
        gap: theme.spacing(1),

        '& > h3': {
          fontSize: '1.6rem',
        },
      },
      '& > section': {
        display: 'grid',
        gridTemplate: 'repeat(3, auto) / repeat(2, 1fr)',
        gap: theme.spacing(0.4),

        '& > span:not(:nth-child(n+2):nth-child(-n+3))': {
          gridColumn: '1 / 3',
        },

        '& > span': {
          backgroundColor: theme.palette.background.default,
          borderRadius: 5,
          padding: theme.spacing(0.4, 2),

          display: 'flex',

          '& > p': {
            fontSize: '1.4rem',
          },

          '& > p:last-child': {
            flex: 1,
            textAlign: 'right',
            fontWeight: 600,
          },

          '&:first-child > p:last-child': {
            textAlign: 'start',
            marginLeft: '1rem',
          },
        },
      },
    },
  }),
)
